import "./App.css";
import { ToastContainer } from "react-toastify";
import Subscribe from "./Components/Subscribe";
import NotFound from "./Components/NotFound";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import ErrorPage from "./Components/ErrorPage";
import DownloadApp from "./Components/DownloadApp";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route exact path="/" element={<Subscribe />}></Route>
        <Route exact path="/subscribe" element={<Subscribe />} />
        <Route element={<NotFound />} />
        <Route exact path="/error" element={<ErrorPage />} />
        <Route exact path="/success" element={<DownloadApp />} />
      </Routes>
    </Router>
  );
}

export default App;
